module.exports = __webpack_public_path__ + "static/media/collapseCircle.ff15a8b3.svg";